import { IAparelhoTipo } from "../interfaces/i-aparelho-tipo";

export class AparelhoTipo implements IAparelhoTipo {
    Id: number;
    Nome: string;
}